import { useIntl } from '@/intl'

import { routesSelector } from '@/scopes/prices/components/selectors'
import { usePricesSelector } from '@/scopes/prices/infrastructure/usePricesSelector'
import { space, tok } from '@sunwebgroup/ui-components'
import { Typography } from '@sunwebgroup/ui-components/uds'
import { useMemo } from 'react'
import { styled } from 'styled-components'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  align-items: baseline;
  padding-bottom: ${space('primitives_space_8')}
`

const DateText = styled(Typography)`
  margin-left: ${space('primitives_space_8')};
  color: ${tok('semantics_content_color')};
`
const DateTitle = styled(Typography)`
  color: ${tok('semantics_content_color')};
`

export function DepartureTitle() {
  const {
    outboundRoute,
  } = usePricesSelector(routesSelector)
  const intl = useIntl()

  const shortDate = useMemo(() => {
    return intl.formatDate(outboundRoute?.departureDate.rawDate, {
      day: 'numeric',
      month: 'short',
      year: 'numeric',
    })
  }, [outboundRoute?.departureDate.rawDate])

  return (
    <Wrapper>
      <DateTitle variant="body-l-bold-snug">
        {intl.formatMessage({ id: 'prices_transport_selector_departure_title' })}
      </DateTitle>
      <DateText variant="body-m-regular-tight">{shortDate}</DateText>
    </Wrapper>
  )
}

export function ArrivalTitle() {
  const {
    inboundRoute,
  } = usePricesSelector(routesSelector)
  const intl = useIntl()

  const isDepartureAndArrivalDateDifferent
    = inboundRoute?.arrivalDate?.fullDate
      && inboundRoute?.departureDate?.fullDate !== inboundRoute?.arrivalDate?.fullDate

  const shortDepartureDate = useMemo(() => {
    return intl.formatDate(inboundRoute?.departureDate.rawDate, {
      day: 'numeric',
      month: 'short',
      year: 'numeric',
    })
  }, [inboundRoute?.departureDate.rawDate])

  const shortArrivalDate = useMemo(() => {
    return intl.formatDate(inboundRoute?.arrivalDate?.rawDate, {
      day: 'numeric',
      month: 'short',
      year: 'numeric',
    })
  }, [inboundRoute?.arrivalDate.rawDate])

  return (
    <Wrapper>
      <DateTitle variant="body-l-bold-snug">
        {intl.formatMessage({ id: 'prices_transport_selector_arrival_title' })}
      </DateTitle>
      <DateText variant="body-m-regular-tight">
        {shortDepartureDate}
        {isDepartureAndArrivalDateDifferent && ` - ${shortArrivalDate}`}
      </DateText>
    </Wrapper>
  )
}
